import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VIcon,_vm._g({style:(_vm.inverse ? undefined : _vm.style),attrs:{"size":_vm.size,"color":_vm.inverse ? _vm.color : 'white'}},_vm.on),[_vm._v("\n  "+_vm._s(_vm.iconName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }